module.exports = __webpack_public_path__ + "static/store-706c42642fbaf7b1111e27b6ae55c059.jpg";